import { connect } from "react-redux";

import Button from "@components/Button";
import HeartMarker from "@components/Icons/HeartMarker";
import { addModal } from "@store/app/actions";
import StoreStockStatus from "@components/ProductPage/ProductStoreAvailability/StoreStockStatus";
import Repeat from "@components/Icons/Repeat";

const StoreSelected = ({ storeData, isStockKnown, addModal }) => {
  const handleAddStoreSelectModal = (event) => {
    event.preventDefault();
    addModal("StoreSelectModal");
  };

  const handleAddAvailableStoresModal = (event) => {
    event.preventDefault();
    addModal("AvailableStoresModal");
  };

  return (
    <div className="flex flex-col lg:flex-row items-start lg:items-center lg:justify-between gap-[8px]">
      <div className="text-[14px] flex flex-col font-medium">
        <span className="flex items-center">
          <HeartMarker /> {storeData.name}{" "}
          <a
            className="text-red-brand cursor-pointer ml-[6px]"
            href="#"
            onClick={handleAddStoreSelectModal}
            rel="noopener noreferrer"
          >
            <Repeat width="18px" height="18px" />
          </a>
        </span>

        {isStockKnown && <StoreStockStatus quantity={storeData.qty} />}
      </div>

      <Button
        title="Vezi in alta locatie"
        isOrderAgain
        variant="third"
        onClick={handleAddAvailableStoresModal}
      />
    </div>
  );
};

export default connect(null, { addModal })(StoreSelected);
